import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getCollectZoneList, getCarList, getDriverList } from "../../crud/search.crud"
import moment from 'moment';
import { changeContractSettlement, contractDetailResponse, getCollectionSettlementList, postMyContract, tradeHistoryCall } from "../../crud/auth.crud"
import Util from "pages/Dashboard/Common/Util";
import _ from "lodash";

import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal_v2";
import SelectBox from "components/RopikCustom/SelectBox";
import { deleteClientData, getContractCompanyList } from "crud/contact.crud";
import Loading from "pages/Custom/Loading";
import * as XLSX from 'xlsx';

const initSearchCondition = {
  companyName: '',
  companyNumber: '',
  cms: '',
  emitterType: '',
  correspondentSize: '',
  settlementDate: '',
  car: '',
  collectZone: '',
  bill: ''
}

const companyType = {
  single: '일반배출자',
  report: '배출신고자',
  many: '다량 배출자',
  multi: '대수(통합) 배출자',
}

const CorrespondentManagementCollection = () => {

  const selector = useSelector(state => state)
  const history = useHistory()
  const code = useSelector((state) => state.Data?.code[0] || [])

  const [collectZoneData, setCollectZoneData] = useState([]);
  const [carData, setCarData] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id)
  const [isLoading, setIsLoading] = useState(false);
  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [modalShow, setModalShow] = useState({
    fileUpload: false,
    delete: false
  })
  const [excelFile, setExcelFile] = useState([])
  const [onUpload, setOnUpload] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [listCount, setListCount] = useState(0)
  const [page, setPage] = useState(1)
  const [correspondentSize, setCorrespondentSize] = useState([])

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollPosition = window.scrollY || document.documentElement.scrollTop
  //     const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
  //     if (scrollPosition >= scrollHeight - 1) {
  //       getDataList();
  //     }
  //   }
  //   window.addEventListener('scroll', handleScroll)

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll)
  //   }
  // }, [dataList])


  const getDataList = async (item) => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading(true)
      const params = {
        page: page,
        company_name: item?.companyName || '',
        company_number: item?.companyNumber || '',
        cms_number: item?.cmsNumber || '',
        client_type: item?.clientType || '',
        emitter_type: item?.companyTyep || '',
        settlement_date: item?.settlementDate || '',
        car: item?.car || '',
        collect_zone: item?.collectZone || '',
        receipt_type: item?.receiptType || '',
      }
      console.log(params)
      const rs = await getContractCompanyList(params);

      if (rs.data?.data) {
        setListCount(rs.data?.data?.length)
        const content = rs.data?.data
        const new_list = [...content]
        setDataList(new_list)
        if (new_list.length >= rs.data.count) {
          setIsListEnd(true)
        }

      }
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
    }
  }


  const getCollectZoneDataList = async () => {
    try {
      const response = await getCollectZoneList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCollectZoneData([...content])
        } else {
          setCollectZoneData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCarDataList = async () => {
    try {
      const response = await getCarList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCarData([...content])
        } else {
          setCarData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const resetSearchCondition = () => {
    setSearchCondition(initSearchCondition)
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
  }

  const deleteClient = async () => {
    const params = {
      company: selectedCompany?.company?.id,
      contract: selectedCompany?.contract?.id,

    }
    const rs = await deleteClientData(params)
    if (rs?.data?.result === 'success') {
      alert('정상적으로 삭제되었습니다.')
      modalClose('delete')
    }
    modalClose('delete')

  }

  const uploadExcelFile = async () => {
    if (onUpload) {
      return
    }
    setOnUpload(true)
    if (excelFile == undefined || excelFile?.length == 0) { setOnUpload(false); return alert('파일을 등록하세요.') }
    try {
      const params = {
        type: 'xlsx',
        category: 'correspondentFile',
        company_id: companyId,
        member_id: myId
      }
      const fd = new FormData();
      fd.append('data', JSON.stringify(params));
      const newFile = new File([excelFile?.[0]], `${encodeURI(excelFile?.[0]?.name)}`, { type: excelFile?.[0]?.type })
      if (excelFile && !_.isEmpty(excelFile)) {
        fd.append('file_0', newFile);
      }

      const response = await console.log(fd)
      if (response?.data?.result === 'success') {
        alert('정상적으로 등록되었습니다.')
      }

    } catch (e) {
      console.log(e)
    }
    setExcelFile([])
    setOnUpload(false)
  }

  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${'거래처 목록'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  const onSearch = async () => {
    getDataList(searchCondition)
  }

  const sampleDownload = async () => {
    const params = {

    }
    const rs = await console.log(params)
    console.log(rs)
  }

  const dateChange = async (date, item) => {

    const response = await changeContractSettlement(item.contract, date)
    if (response.status === 200) {
      getDataList()
    } else {
      alert('정산날짜 변경에 실패하였습니다.')
    }

  }

  const registFiles = (e) => {
    setExcelFile([...e.target.files])
  }

  const makeCodeArr = (str, callback) => {
    let codes = code.filter(itm => itm.code == str)
    let tmp = []
    for (let i = 0; i < codes.length; i++) {
      let itm = {
        id: codes[i]?.key,
        name: codes[i]?.text
      }
      tmp.push(itm)
    }
    callback(tmp)
  }

  useEffect(() => {
    getCollectZoneDataList()
    getCarDataList()
    getDataList()
    makeCodeArr('client_type', setCorrespondentSize)
  }, [])

  return (
    <React.Fragment>

      <div className="d-flex w-100 gap-30 align-items-center">
        <div className="email-rightbar flex-grow-1">
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <tbody>
                  <tr>
                    <td className="col-10 padding-left-8 primary-bg white-text">상호명</td>
                    <td className="col-20">
                      <input className="is-touched is-dirty av-valid form-control font-size-14 w-80 border-radius-0" placeholder="상호명 입력" value={searchCondition.companyName} onChange={(e) => {
                        changeSearchCondition('companyName', e.target.value)
                      }} />
                    </td>
                    <td className="col-10 padding-left-8 primary-bg white-text">사업자번호</td>
                    <td className="col-20">
                      <input className="is-touched is-dirty av-valid form-control font-size-14 w-80 border-radius-0" placeholder="사업자 번호 입력" value={searchCondition.businessNumber} onChange={(e) => {
                        changeSearchCondition('companyNumber', e.target.value)
                      }} />
                    </td>
                    <td className="col-10 padding-left-8 primary-bg white-text">신고대상여부</td>
                    <td className="col-20">
                      <SelectBox
                        value={searchCondition?.correspondentSize}
                        onChange={changeSearchCondition}
                        options={correspondentSize}
                        keyValue={'correspondentSize'}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="col-10 padding-left-8 primary-bg white-text">결산일</td>
                    <td className="col-20">
                      <select className='waver-select-box w-80 border-radius-0' value={searchCondition.settlementDate} onChange={(e) => {
                        changeSearchCondition('settlementDate', e.target.value)
                      }}>
                        <option value="" >{'선택'}</option>
                        {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                          <option key={day} value={day}>
                            {day}일
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="col-10 padding-left-8 primary-bg white-text">수거구역</td>
                    <td className="col-20">
                      <SelectBox
                        value={searchCondition.collectZone}
                        onChange={changeSearchCondition}
                        options={collectZoneData}
                        keyValue={'collectZone'}
                      />
                    </td>
                    <td className="col-10 padding-left-8 primary-bg white-text"></td>
                    <td className="col-20">
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
        <div className="d-flex flex-direction-column align-items-end">
          <button type="button" className="custom-btn btn-dark-gradient margin-bottom-8 border-radius-0 white-text border-none margin-right-0" onClick={() => {
            onSearch()
          }}>
            검색
          </button>
          <button type="button" className="custom-btn margin-bottom-8 border-radius-0 primary-bg white-text button-border margin-right-0" onClick={() => {
            history.push('/correspondent-write')
          }}>
            거래처 등록
          </button>
          <button type="button" className="custom-btn border-radius-0 tertiary-bg white-text button-border margin-right-0" onClick={(e) => {
            modalOpen('fileUpload')
          }}>
            거래처 파일 등록
          </button>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2 margin-top-25">
        <p className="mb-0 font-size-16"><span className="font-weight-bold">거래처 목록</span> [ 건수 : {dataList.length}건 ]</p>
        <div className="waver-pagination-btn-group" >
          <button style={{ width: 143 }} className="custom-btn success-bg border-radius-0 white-text border-none margin-right-0"
            onClick={() => {
              excelDownload()
            }} >
            엑셀 다운로드
          </button>
        </div>
      </div>
      <Row>
        <Col xs="12">
          <div className="email-rightbar mb-3">

            <Card>
              <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                <div className="table-responsive">
                  <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                    <thead className="chart-thead">
                      <tr>
                        <th scope="col">No</th>
                        {/* <th scope="col">구분</th> */}
                        <th scope="col">상호</th>
                        <th scope="col">수거구역</th>
                        <th scope="col">사업장 규모</th>
                        <th scope="col">사업장 번호</th>
                        <th scope="col">계산서 구분</th>
                        <th scope="col">결산일</th>
                        <th scope="col">요금제</th>
                        <th scope="col">단가</th>
                        <th scope="col">기본금액</th>
                        <th scope="col">기본량</th>
                        <th scope="col">단위</th>
                        <th scope="col">삭제</th>
                      </tr>
                    </thead>
                    <tbody className="chart-tbody">
                      {dataList.map((item, index) => {
                        return (
                          <tr className="pointer" key={item.id + '_' + index} onClick={() => {
                            history.push({ pathname: '/correspondent-edit', state: { company: item?.company, contract: item?.contract } })
                          }}>
                            <td>{dataList.length - index}</td>
                            {/* <td>{item?.company_type}</td> */}
                            <td>{item?.company?.name}</td>
                            <td>{item?.collect_zone_name}</td>
                            <td>{correspondentSize.filter(itm => itm.id = item?.contract?.client_type)?.[0]?.name || ''}</td>
                            <td>{item?.company?.company_number}</td>
                            <td>{item?.contract?.receipt_type == 'N' ? '비과세' : '과세'}</td>
                            <td>{item.contract?.settlement_date + '일'}</td>
                            <td>{item?.contract?.billing_type == 'P' ? '종량제' : '정액제'}</td>
                            <td>{Util.setPrice(item?.contract?.collect_type == 'l' ? item?.contract?.price_per_l || 0 : item?.contract?.price_per_kg_emitter || 0)}</td>
                            <td>{Util.setPrice(item?.contract?.min_price)} 원</td>
                            <td>{Util.setPrice(item?.contract?.collect_type == 'l' ? item?.contract?.min_l || 0 : item?.contract?.min_kg || 0)}</td>
                            <td>{item?.contract?.collect_type == 'l' ? 'ℓ' : 'kg'}</td>
                            <td>
                              <div className="btn-group waver-common-btn-group">
                                <Button type="button" size="sm" className="waves-effect center-btn btn-common small disactive" onClick={(e) => {
                                  e.stopPropagation()
                                  modalOpen('delete')
                                  setSelectedCompany(item)
                                }}>삭제</Button>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                      {dataList.length === 0 &&
                        <tr>
                          <td scope="row" colSpan="14">데이터가 없습니다.</td>
                        </tr>
                      }

                    </tbody>
                  </table>
                </div>
              </CardBody>
              {isLoading && <Loading />}
            </Card>

          </div>
        </Col>
      </Row>

      <Modal
        title={'거래처 삭제'}
        show={modalShow.delete}
        onHide={() => {
          modalClose('delete')
          setSelectedCompany(null)
        }}
        size="md"
        bodyChildren={
          <p>선택된 거래처가 삭제됩니다. 정말 삭제 하시겠습니까?</p>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              deleteClient()
            }}>
              삭제
            </button>
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
              modalClose('delete')
              setSelectedCompany(null)
            }}>
              취소
            </button>
          </div>
        }
      >
      </Modal>

      <Modal
        title={'거래처 리스트 업로드(거래처 일괄 등록)'}
        show={modalShow.fileUpload}
        onHide={() => { modalClose('fileUpload') }}
        size="lg"
        bodyChildren={
          <Fragment>
            <div className="download-container d-flex justify-content-between">
              <div className="padding-top-14 padding-bottom-14">
                <p className="margin-bottom-10 font-size-11">엑셀 파일 내 필수 항목은 모두 입력이 되어야 합니다.</p>
                <p className="font-size-11 font-weight-bold mb-0">※ 필수 항목 미입력 시 거래처 업로드에 오류가 있을 수 있습니다.</p>
              </div>
              <div>
                <button style={{ width: 182 }} className="custom-btn border-radius-0 tertiary-bg white-text border-none margin-right-0 font-size-11" onClick={() => {
                  sampleDownload()
                }}>샘플 엑셀파일 다운로드</button>
              </div>
            </div>
            <div className="margin-top-14 d-flex">
              <input className="d-none" type="file" accept=".xls,.xlsx" id="ex_file" onChange={(e) => {
                registFiles(e)
              }} />
              <label htmlFor="ex_file" style={{ width: 112, height: 27 }} className="custom-btn border-radius-0 font-size-11 line-height-1 tertiary-bg white-text border-none mb-0 pointer text-center" onChange={(e) => { setExcelFile(e.target.files) }}>파일선택</label>
              <p>{excelFile?.[0]?.name}</p>
            </div>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <div className="d-flex">
              <button style={{ width: 112, height: 27 }} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
                uploadExcelFile()
              }}>파일 업로드</button>
              <button style={{ width: 59, height: 27 }} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
                modalClose('fileUpload')
              }}>취소</button>
            </div>
          </div>
        }
      />
    </React.Fragment>
  )
}

export default CorrespondentManagementCollection
